/**
 * Utility to load environment-specific configurations
 */

import defaultSettings from '../appSettings.json';
import stagingSettings from '../appSettings.staging.json';
import productionSettings from '../appSettings.production.json';

/**
 * Get the appropriate settings based on the current environment
 */
export const getEnvironmentSettings = () => {
    const environment = process.env.REACT_APP_ENV || 'development';

    switch (environment) {
        case 'staging':
            return stagingSettings;
        case 'production':
            return productionSettings;
        default:
            return defaultSettings;
  }
};

export default getEnvironmentSettings;
